import AbstractInstaller from "../core/AbstractInstaller";

/**
 * SkinKeys is a generic object which functions as sort of a dictionary, for storing SkinKey objects.
 * @see AbstractInstaller._mapMediator
 * @type {Object} 
 */
const SkinKeys = {};
export default SkinKeys;
